// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.sc-alert-close {
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  margin-left: 16px;
  opacity: 0.65;
  padding: 0 4px;
}
.sc-alert-close:hover {
  opacity: 1;
}

.sc-report-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin-bottom: 16px;
}
.sc-report-row label {
  color: #1f2937;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
}

.sc-record {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.sc-record:last-of-type {
  border-bottom: none;
}

.sc-section {
  border: 1px solid #dde2e8;
  border-radius: 4px;
  padding: 14px 16px;
}

.sc-section-layout {
  align-items: flex-start;
  display: flex;
  gap: 14px;
  justify-content: space-between;
}

.sc-section-main {
  flex: 1 1 auto;
  min-width: 0;
}

.sc-section-title {
  color: #0d5ca8;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 12px;
}

.sc-title-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  margin-bottom: 12px;
}
.sc-title-row .sc-section-title {
  margin-bottom: 0;
}

.sc-add-btn {
  white-space: nowrap;
  align-self: flex-start;
}

.sc-report-name {
  flex: 0 1 320px;
  min-width: 220px;
}

.sc-field-grid {
  display: grid;
  gap: 12px 28px;
  width: 100%;
}

.sc-field-grid--single {
  grid-template-columns: minmax(260px, 420px);
}

.sc-field-grid--two {
  grid-template-columns: repeat(2, minmax(220px, 360px));
}

.sc-field-grid--three {
  grid-template-columns: repeat(3, minmax(210px, 1fr));
}

.sc-field {
  align-items: center;
  display: grid;
  grid-template-columns: max-content minmax(96px, 1fr);
  column-gap: 12px;
  min-width: 0;
}
.sc-field label {
  color: #1f2937;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  white-space: nowrap;
}
.sc-field input {
  min-width: 0;
}

.sc-field--compact {
  grid-template-columns: max-content 90px;
  width: auto;
}

.sc-rheology-grid {
  display: grid;
  gap: 10px 12px;
  grid-template-columns: repeat(auto-fit, minmax(72px, 82px));
}

.sc-stack-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.sc-stack-field label {
  color: #1f2937;
  font-size: 0.83rem;
  font-weight: 600;
  line-height: 1.1;
  margin: 0;
}
.sc-stack-field input {
  width: 100%;
}

@media (max-width: 991.98px) {
  .sc-field-grid--three {
    grid-template-columns: repeat(2, minmax(210px, 1fr));
  }
}
@media (max-width: 767.98px) {
  .sc-section-layout {
    flex-direction: column;
  }
  .sc-field-grid,
  .sc-field-grid--single,
  .sc-field-grid--two,
  .sc-field-grid--three {
    grid-template-columns: 1fr;
  }
  .sc-add-btn {
    align-self: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/service-company/service-company.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;AACF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAAF;AAEE;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;;AAKA;EACE,cAAA;EACA,gCAAA;AAFF;AAIE;EACE,mBAAA;AAFJ;;AAOA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,uBAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;AAJF;;AAOA;EACE,cAAA;EACA,YAAA;AAJF;;AAOA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAJF;AAME;EACE,gBAAA;AAJJ;;AAQA;EACE,mBAAA;EACA,sBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,cAAA;EACA,WAAA;AALF;;AAQA;EACE,2CAAA;AALF;;AAQA;EACE,sDAAA;AALF;;AAQA;EACE,oDAAA;AALF;;AAQA;EACE,mBAAA;EACA,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,YAAA;AALF;AAOE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AALJ;AAQE;EACE,YAAA;AANJ;;AAUA;EACE,uCAAA;EACA,WAAA;AAPF;;AAUA;EACE,aAAA;EACA,cAAA;EACA,2DAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAPF;AASE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AAPJ;AAUE;EACE,WAAA;AARJ;;AAYA;EACE;IACE,oDAAA;EATF;AACF;AAYA;EACE;IACE,sBAAA;EAVF;EAaA;;;;IAIE,0BAAA;EAXF;EAcA;IACE,sBAAA;EAZF;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.sc-alert-close {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  color: inherit;\n  cursor: pointer;\n  font-size: 1.25rem;\n  font-weight: 700;\n  line-height: 1;\n  margin-left: 16px;\n  opacity: 0.65;\n  padding: 0 4px;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.sc-report-row {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  margin-bottom: 16px;\n\n  label {\n    color: #1f2937;\n    font-weight: 700;\n    margin: 0;\n    white-space: nowrap;\n  }\n}\n\n// Separator between consecutive records in a section\n.sc-record {\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n\n  &:last-of-type {\n    border-bottom: none;\n  }\n}\n\n// Boxed section (Density, Rheology, Electrical Stability, Fluid Loss, Chemistries, Solids Analysis)\n.sc-section {\n  border: 1px solid #dde2e8;\n  border-radius: 4px;\n  padding: 14px 16px;\n}\n\n.sc-section-layout {\n  align-items: flex-start;\n  display: flex;\n  gap: 14px;\n  justify-content: space-between;\n}\n\n.sc-section-main {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.sc-section-title {\n  color: #0d5ca8;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0 0 12px;\n}\n\n.sc-title-row {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 24px;\n  margin-bottom: 12px;\n\n  .sc-section-title {\n    margin-bottom: 0;\n  }\n}\n\n.sc-add-btn {\n  white-space: nowrap;\n  align-self: flex-start;\n}\n\n.sc-report-name {\n  flex: 0 1 320px;\n  min-width: 220px;\n}\n\n.sc-field-grid {\n  display: grid;\n  gap: 12px 28px;\n  width: 100%;\n}\n\n.sc-field-grid--single {\n  grid-template-columns: minmax(260px, 420px);\n}\n\n.sc-field-grid--two {\n  grid-template-columns: repeat(2, minmax(220px, 360px));\n}\n\n.sc-field-grid--three {\n  grid-template-columns: repeat(3, minmax(210px, 1fr));\n}\n\n.sc-field {\n  align-items: center;\n  display: grid;\n  grid-template-columns: max-content minmax(96px, 1fr);\n  column-gap: 12px;\n  min-width: 0;\n\n  label {\n    color: #1f2937;\n    font-size: 0.875rem;\n    font-weight: 600;\n    line-height: 1.2;\n    margin: 0;\n    white-space: nowrap;\n  }\n\n  input {\n    min-width: 0;\n  }\n}\n\n.sc-field--compact {\n  grid-template-columns: max-content 90px;\n  width: auto;\n}\n\n.sc-rheology-grid {\n  display: grid;\n  gap: 10px 12px;\n  grid-template-columns: repeat(auto-fit, minmax(72px, 82px));\n}\n\n.sc-stack-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n\n  label {\n    color: #1f2937;\n    font-size: 0.83rem;\n    font-weight: 600;\n    line-height: 1.1;\n    margin: 0;\n  }\n\n  input {\n    width: 100%;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .sc-field-grid--three {\n    grid-template-columns: repeat(2, minmax(210px, 1fr));\n  }\n}\n\n@media (max-width: 767.98px) {\n  .sc-section-layout {\n    flex-direction: column;\n  }\n\n  .sc-field-grid,\n  .sc-field-grid--single,\n  .sc-field-grid--two,\n  .sc-field-grid--three {\n    grid-template-columns: 1fr;\n  }\n\n  .sc-add-btn {\n    align-self: flex-start;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
